import { getuploaddocuments } from "../../utils/apiFunctions";
const hrMixin = {
  methods: {
    async getAssignedDocs(data) {
      try {
        this.reassign = true;
        this.selectedCandidateID = data.RecCandidateID;
        this.expiryDate = data.expiryDate;
        this.selectedDocs = data.document.documents;
        let decldoc = data.document.decForm;
        this.selectedDecDocs = [];

        await this.getDocuments();
        for (let i in decldoc) {
          for (let j in this.documentDetails) {
            if (this.documentDetails[j].documentID == decldoc[i].value) {
              this.selectedDecDocs.push({
                name: this.documentDetails[j].documentName,
                value: this.documentDetails[j].documentID,
              });
            }
          }
        }
        if (data.document.employeeDetails) {
          this.selectedRegForm.push("employeeDetails");
        }
        if (data.document.educationalDetails) {
          this.selectedRegForm.push("educationalDetails");
        }
        if (data.document.familyDetails) {
          this.selectedRegForm.push("familyDetails");
        }
        if (data.document.nomineeDetails) {
          this.selectedRegForm.push("nomineeDetails");
        }
        if (data.document.workDetails) {
          this.selectedRegForm.push("workDetails");
        }
        this.$bvModal.show("assign-docs");
        this.loaderStatus = false;
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    async getDocuments() {
      try {
        const response = await getuploaddocuments();
        this.documentDetails = response.data.data;
      } catch (error) {
        throw new Error(`Failed! getDocuments ! status: ${error.status}`);
      }
    },
    // HELPER FUNCTIONS --START
    toCamelCase(str) {
      let arr = str.match(/[a-z]+|\d+/gi);
      return arr.map((m, i) => {
        let low = m.toLowerCase();
        if (i != 0) {
          low = low.split("").map((s, k) => (k == 0 ? s.toUpperCase() : s))
            .join``;
        }
        return low;
      }).join``;
    },
    // TOGGLE DROP DOWN IN ASSIGN DOCS MODAL
    toggleDropDown(index) {
      this.dropDownToggle[index] = !this.dropDownToggle[index];
      let current = this.dropDownToggle[index];
      for (let i in this.dropDownToggle) {
        if (i != index) {
          if (current) {
            this.dropDownToggle[i] = false;
          }
        }
      }
      this.$forceUpdate();
    },
  },
};
export default hrMixin;
